import React from 'react';

interface IProps {
    accountHandle?: string;
    className?: string;
    style?: React.CSSProperties;
    src?: string;
}

export default function ProfilePicture(props: IProps) {
    return (
        <img
            alt={props.accountHandle}
            className={props.className}
            crossOrigin='anonymous'
            draggable={false}
            src={props.src}
            style={props.style}
        />
    );
}
